

export const SidePanelHeader = (props: any) => {
	return (
		<div className='side-panel-header'>
			{props.children}
		</div>
	);
};
